'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/add/Add.tsx
import { jsx } from "react/jsx-runtime";
var AddIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "14",
      height: "14",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/add/CircleAdd.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CircleAdd = (props) => /* @__PURE__ */ jsx2(
  "svg",
  __spreadProps(__spreadValues({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00033 1.91663C5.08831 1.91663 1.91699 5.08794 1.91699 8.99996C1.91699 12.912 5.08831 16.0833 9.00033 16.0833C12.9123 16.0833 16.0837 12.912 16.0837 8.99996C16.0837 5.08794 12.9123 1.91663 9.00033 1.91663ZM0.666992 8.99996C0.666992 4.39759 4.39795 0.666626 9.00033 0.666626C13.6027 0.666626 17.3337 4.39759 17.3337 8.99996C17.3337 13.6023 13.6027 17.3333 9.00033 17.3333C4.39795 17.3333 0.666992 13.6023 0.666992 8.99996ZM9.00033 4.8398C9.3455 4.8398 9.62533 5.11963 9.62533 5.4648V8.37534H12.5359C12.881 8.37534 13.1609 8.65516 13.1609 9.00034C13.1609 9.34552 12.881 9.62534 12.5359 9.62534H9.62533V12.5359C9.62533 12.881 9.3455 13.1609 9.00033 13.1609C8.65515 13.1609 8.37533 12.881 8.37533 12.5359V9.62534H5.46479C5.11961 9.62534 4.83979 9.34552 4.83979 9.00034C4.83979 8.65516 5.11961 8.37534 5.46479 8.37534H8.37533V5.4648C8.37533 5.11963 8.65515 4.8398 9.00033 4.8398Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  AddIcon,
  CircleAdd
};
//# sourceMappingURL=chunk-YRGQTVJ4.mjs.map